import React from "react";


const ReportContent = ({data}) => {
    return(
        <>
            <div>
                <table className="table report-table">
                    <thead className="thead-background">
                        <tr className={"text-left"}>
                            <th className="w-[15%]">D/H da entrega</th>
                            <th className="w-[25%]">Solicitante</th>
                            <th className="w-[25%]">Depósito</th>
                            <th className="w-[20%]">Material</th>
                            <th className="w-[15%]">Quantidade</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data.map(d => {
                        return(
                            <>
                                <tr>
                                    <td>{d.date}</td>
                                    <td>{d.requester ?? ""}</td>
                                    <td>{d.storage ?? ""}</td>
                                    <td>{d.material ?? ""}{d.serial ? ` - ${d.serial}` : ""}</td>
                                    <td>{d.quantity ?? ""}</td>
                                </tr>
                            </>
                        )
                    })
                    }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ReportContent;